import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CheckCircle, Warning } from '@phosphor-icons/react';
import AdminLayout from '../components/AdminLayout';
import { PortalAccessPanel } from '../components/PortalAccessPanel';
import API_URL from '../config';

export default function AdminPlanCoverage() {
  const [data, setData] = useState({ contacts: [], total: 0, missing: 0 });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/admin/pp-coverage`);
      setData(res.data);
    } catch (e) {
      toast.error('Failed to load coverage report');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  return (
    <AdminLayout>
      <div className="max-w-6xl mx-auto space-y-6" data-testid="admin-coverage">
        <div>
          <h1 className="text-2xl font-bold" style={{ color: '#141b4d' }}>Protection Plan Coverage</h1>
          <p className="text-sm mt-1" style={{ color: '#71717A' }}>
            Every HubSpot contact that qualifies as a Protection Plan client (active coverage).{' '}
            {data.missing > 0 && <span className="font-semibold" style={{ color: '#B45309' }}>{data.missing} missing portal account(s).</span>}
          </p>
        </div>

        <PortalAccessPanel onApplied={load} />

        {loading ? <p className="text-sm text-[#71717A]">Loading…</p> : (
          <div className="overflow-hidden border border-[#E4E4E7]">
            <table className="w-full text-sm">
              <thead className="bg-[#FAFAF8]">
                <tr className="text-left" style={{ color: '#71717A' }}>
                  <th className="px-3 py-2">Name</th>
                  <th className="px-3 py-2">Email</th>
                  <th className="px-3 py-2">Plan</th>
                  <th className="px-3 py-2">Coverage ends</th>
                  <th className="px-3 py-2">Portal account</th>
                </tr>
              </thead>
              <tbody data-testid="coverage-table">
                {data.contacts.map((c) => (
                  <tr key={c.contact_id} className="border-t border-[#F4F4F5]">
                    <td className="px-3 py-2" style={{ color: '#09090B' }}>{c.name || '—'}</td>
                    <td className="px-3 py-2" style={{ color: '#52525B' }}>{c.email}</td>
                    <td className="px-3 py-2" style={{ color: '#52525B' }}>{c.plan}</td>
                    <td className="px-3 py-2" style={{ color: '#52525B' }}>{c.coverage_end || 'No end date'}</td>
                    <td className="px-3 py-2">
                      {c.has_portal_account
                        ? <span className="inline-flex items-center gap-1" style={{ color: '#16A34A' }}>
                            <CheckCircle weight="fill" className="w-4 h-4" /> Yes</span>
                        : <span className="inline-flex items-center gap-1 font-semibold" style={{ color: '#B45309' }}>
                            <Warning weight="fill" className="w-4 h-4" /> No account</span>}
                    </td>
                  </tr>
                ))}
                {data.contacts.length === 0 && (
                  <tr><td colSpan={5} className="px-3 py-6 text-center" style={{ color: '#A1A1AA' }}>No qualifying contacts found.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
